/* eslint-disable max-classes-per-file */
import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { CommandBase } from "../../../../common/services/cqs/commandManager";
import { IGeolocationDto } from "./queries";

export class TransporttilldelaArbetsorderCommand extends BasicCommand<TransporttilldelaArbetsorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<TransporttilldelaArbetsorderCommand>;
    transportforetagId: number;
    arbetsorderIds: number[];

    constructor() {
        super("TransporttilldelaArbetsorderCommand", "arbetsorder", CommandType.Insert);
    }
}

export interface ITransportforetagHs {
    transportforetagId: number;
    handelssortimentId: number;
    arbetsorderId: number;
}

export class TransporttilldelaHandelssortimentCommand extends BasicCommand<TransporttilldelaHandelssortimentCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<TransporttilldelaHandelssortimentCommand>;
    transportforetagId: number;
    befraktareId: number;
    egenTransport = true;
    handelssortimentId: number;
    arbetsorderIds: number[];

    constructor() {
        super("TransporttilldelaHandelssortimentCommand", "arbetsorderHandelssortiment", CommandType.Insert);
    }
}

export interface IMottagningsplatsAndel {
    mottagningsplatsId: number;
    foradlatHandelssortimentId: number;
    mottagningsplatsRef: string;
    andel: number;
}

export class DestineraArbetsordrarCommand extends CommandBase {
    destineringar: IMottagningsplatsAndel[];
    arbetsorderIdList: number[];

    constructor(arbetsorderIdList: number[], readonly handelssortimentId: number) {
        super("DestineraArbetsordrarCommand");
        this.arbetsorderIdList = arbetsorderIdList;
        this.destineringar = [
            {
                mottagningsplatsId: null,
                foradlatHandelssortimentId: null,
                mottagningsplatsRef: null,
                andel: null
            }
        ];
    }
}

export class SetDestineringActiveCommand extends BasicCommand<SetDestineringActiveCommand> {
    get primaryKey() {
        return {
            destineringsId: this.destineringsId
        };
    }

    $type: string;
    destineringsId: number;
    active: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetDestineringActiveCommand";

    constructor(
        destineringsId: number,
        active: boolean
    ) {
        super("SetDestineringActiveCommand", "Destinering", CommandType.Replace);
        this.$type = "SetDestineringActiveCommand";
        this.destineringsId = destineringsId;
        this.active = active;
    }
}

export class RemoveArbetsorderIntressentCommand {
    $type: string;
    arbetsorderIds: number[];

    constructor(arbetsorderIds: number[]) {
        this.$type = "RemoveArbetsorderIntressentCommand";
        this.arbetsorderIds = arbetsorderIds;
    }
}

export class SetJusteratAvstandCommand extends CommandBase {
    $type: string;
    arbetsorderId: number;
    mottagningsplatsId: number;
    barighetsklass: string;
    extraKm: number;
    krontVagvalMotstand: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetJusteratAvstandCommand";
    constructor(
        arbetsorderId: number,
        mottagningsplatsId: number,
        barighetsklass: string,
        extraKm: number
    ) {
        super(SetJusteratAvstandCommand.$type);
        this.arbetsorderId = arbetsorderId;
        this.mottagningsplatsId = mottagningsplatsId;
        this.barighetsklass = barighetsklass;
        this.extraKm = extraKm;
    }
}

export class SetTillaggsavstandStorstaAvlaggCommand extends CommandBase {
    arbetsorderId: number;
    tillaggsavstandStorstaAvlagg: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetTillaggsavstandStorstaAvlaggCommand";
    constructor(
        arbetsorderId: number,
        tillaggsavstandStorstaAvlagg: number
    ) {
        super(SetTillaggsavstandStorstaAvlaggCommand.$type);
        this.arbetsorderId = arbetsorderId;
        this.tillaggsavstandStorstaAvlagg = tillaggsavstandStorstaAvlagg;
    }
}

export class MoveArbetsorderStartpunktCommand extends CommandBase {
    arbetsorderId: number;
    startPoint: IGeolocationDto;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MoveArbetsorderStartpunktCommand";
    constructor(
        arbetsorderId: number,
        startPoint: IGeolocationDto
    ) {
        super(MoveArbetsorderStartpunktCommand.$type);
        this.arbetsorderId = arbetsorderId;
        this.startPoint = startPoint;
    }
}

export class UpdateViapunkterCommand extends CommandBase {
    arbetsorderId: number;
    mottagningsplatsId: number;
    barighetsklass: string;
    viapunkter: IGeolocationDto[];
    vagmotstand: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateViapunkterCommand";
    constructor(
        arbetsorderId: number,
        mottagningsplatsId: number,
        barighetsklass: string,
        vagmotstand: number,
        viapunkter: IGeolocationDto[]
    ) {
        super(UpdateViapunkterCommand.$type);
        this.arbetsorderId = arbetsorderId;
        this.mottagningsplatsId = mottagningsplatsId;
        this.barighetsklass = barighetsklass;
        this.viapunkter = viapunkter;
        this.vagmotstand = vagmotstand;
    }
}

export class MassUpdateViapunkterCommand extends CommandBase {
    arbetsorderId: number;
    viapunkter: IGeolocationDto[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MassUpdateViapunkterCommand";
    constructor(
        arbetsorderId: number,
        viapunkter: IGeolocationDto[]
    ) {
        super(MassUpdateViapunkterCommand.$type);
        this.arbetsorderId = arbetsorderId;
        this.viapunkter = viapunkter;
    }
}

export class UpdateArbetsorderTransportavstandGeometryCommand extends CommandBase {
    arbetsorderId: number;
    mottagningsplatsId: number;
    barighetsklass: string;
    routeGeometry: string;
    felmeddelandekod: string;
    vagmotstand: number;
    krontVagvalKm?: number;
    berakningstid?: Date;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateArbetsorderTransportavstandGeometryCommand";
    // constructor(
    //     // arbetsorderId: number,
    //     // mottagningsplatsId: number,
    //     // barighetsklass: string,
    //     // routeGeometry: string,
    //     // felmeddelandekod: string,
    //     // vagmotstand: number,
    //     // krontVagvalKm?: number,
    //     // berakningstid?: Date
    // ) {
    //     super(UpdateArbetsorderTransportavstandGeometryCommand.$type);
    //     // this.arbetsorderId = arbetsorderId;
    //     // this.mottagningsplatsId = mottagningsplatsId;
    //     // this.barighetsklass = barighetsklass;
    //     // this.routeGeometry = routeGeometry;
    //     // this.felmeddelandekod = felmeddelandekod;
    //     // this.vagmotstand = vagmotstand;
    //     // this.krontVagvalKm = krontVagvalKm;
    //     // this.berakningstid = berakningstid;
    // }
    constructor(init: (instance: UpdateArbetsorderTransportavstandGeometryCommand) => void) {
        super(UpdateArbetsorderTransportavstandGeometryCommand.$type);
        init(this);
    }
}

export class ClearDestineringAndelArbetsordrarCommand extends CommandBase {
    arbetsorderIdList: number[];
    handelssortimentId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ClearDestineringAndelArbetsordrarCommand";

    constructor(arbetsorderIdList: number[], handelssortimentId: number) {
        super(ClearDestineringAndelArbetsordrarCommand.$type);
        this.arbetsorderIdList = arbetsorderIdList;
        this.handelssortimentId = handelssortimentId;
    }

}
